module.exports = __webpack_public_path__ + "img/taipa_village_art_space.679b7306.jpg";